<template>
  <div class="home-details">
    <page-header :title="title" />
    <div class="pessoa-home-container grey lighten-5 pa-3 pt-1 overflow-y-auto">
      <v-row class="mt-3" no-gutters>
        <v-col cols="12" sm="4" md="3" class="d-flex justify-center pa-0 ma-0">
          <div
            class="
              d-flex
              flex-fill
              justify-center justify-sm-start
              ml-1
              mb-2 mb-md-4
            "
          >
            <v-avatar
              v-if="pessoa.data.fotoPerfil === '::restrict::'"
              :size="
                $vuetify.breakpoint.smAndDown
                  ? '156'
                  : $vuetify.breakpoint.mdAndDown
                  ? '140'
                  : '160'
              "
              :tile="!$vuetify.breakpoint.smAndDown"
              @click="showPhotoFullscreen = false"
              :title="$t('restrito_usuario')"
            >
              <v-icon
                style="
                  position: absolute;
                  top: -40px;
                  left: -50px;
                  opacity: 0.65;
                "
                size="30"
                >mdi-lock</v-icon
              >
              <v-img style="opacity: 0.4" src="/img/person-avatar.png" alt="" />
            </v-avatar>
            <v-avatar
              v-else
              :size="
                $vuetify.breakpoint.smAndDown
                  ? '156'
                  : $vuetify.breakpoint.mdAndDown
                  ? '140'
                  : '160'
              "
              :tile="!$vuetify.breakpoint.smAndDown"
              @click="showPhotoFullscreen = true"
            >
              <div
                v-if="
                  $store.getters['pessoa/isRestrict']('fotoPerfil') &&
                  $store.state.auth.user.token
                "
                style="position: absolute; top: 0; left: 0"
              >
                <v-icon
                  size="30px"
                  color="grey"
                  style="margin-bottom: 2px; opacity: 0.8"
                  dark
                  >mdi-lock</v-icon
                >
              </div>
              <v-img
                :src="
                  !pessoa.data.fotoPerfil
                    ? '/img/person-avatar.png'
                    : $store.state.profileImageURL + pessoa.data.fotoPerfil
                "
                alt=""
              />
            </v-avatar>
            <photo-fullscreen
              v-model="showPhotoFullscreen"
              :img="
                !pessoa.data.fotoPerfil
                  ? '/img/person-avatar.png'
                  : $store.state.profileImageURL + pessoa.data.fotoPerfil
              "
            />
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="8"
          md="9"
          class="d-flex flex-column justify-start pl-sm-8 pl-lg-5 m-0"
        >
          <div v-if="pessoa.data.nome || !$store.state.hideNoFilled">
            <restrict-icon
              :is-restrict="$store.getters['pessoa/isRestrict']('nome')"
            />
            <label class="text-caption grey--text text--darken-2">
              {{ $t("Nome_Completo") }}
            </label>
            <restrict-chip :value="pessoa.data.nome">
              <div v-if="pessoa.data.nome" class="title">
                {{ pessoa.data.nome }}
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ noInfo }}
                </i>
              </div>
            </restrict-chip>
          </div>
          <div class="d-flex flex-wrap">
            <div
              v-if="pessoa.data.genero || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('genero')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Genero") }}
              </label>
              <restrict-chip :value="pessoa.data.genero">
                <div v-if="pessoa.data.genero" class="subtitle-2">
                  {{ pessoa.data.genero }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.dataNasc || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('dataNasc')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Idade") }}
              </label>
              <restrict-chip :value="pessoa.data.dataNasc">
                <div v-if="pessoa.data.dataNasc" class="subtitle-2">
                  {{ pessoa.data.dataNasc | toAge }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.peso || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('peso')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Peso") }}
              </label>
              <restrict-chip :value="pessoa.data.peso">
                <div v-if="pessoa.data.peso" class="subtitle-2">
                  {{ convertValue(pessoa.data.peso, { type: "decimal" }) }} Kg
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.altura || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('altura')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Altura") }}
              </label>
              <restrict-chip :value="pessoa.data.altura">
                <div v-if="pessoa.data.altura" class="subtitle-2">
                  {{ convertValue(pessoa.data.altura, { type: "decimal" }) }} m
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.tipoSangue || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('tipoSangue')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Tipo_Sangue") }}
              </label>
              <restrict-chip :value="pessoa.data.tipoSangue">
                <div v-if="pessoa.data.tipoSangue" class="subtitle-2">
                  {{ pessoa.data.tipoSangue }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div
            v-if="pessoa.data.email || !$store.state.hideNoFilled"
            class="d-flex flex-wrap"
          >
            <div class="mr-6 my-2">
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('email')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Email") }}
              </label>
              <restrict-chip :value="pessoa.data.email">
                <div v-if="pessoa.data.email" class="subtitle-2">
                  {{ pessoa.data.email }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.fone1Contato || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pessoa/isRestrict']('fone1Contato')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Telefone_Contato") }}
              </label>
              <restrict-chip :value="pessoa.data.fone1Contato">
                <div v-if="pessoa.data.fone1Contato" class="subtitle-2">
                  {{ pessoa.data.fone1Contato }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.nomeContato || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pessoa/isRestrict']('nomeContato')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Nome_Contato") }}
              </label>
              <restrict-chip :value="pessoa.data.nomeContato">
                <div v-if="pessoa.data.nomeContato" class="subtitle-2">
                  {{ pessoa.data.nomeContato }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.cep || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('cep')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("CEP") }}
              </label>
              <restrict-chip :value="pessoa.data.cep">
                <div v-if="pessoa.data.cep" class="subtitle-2">
                  {{ pessoa.data.cep }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pessoa.data.medicamentos || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pessoa/isRestrict']('medicamentos')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Medicamentos") }}
              </label>
              <restrict-chip :value="pessoa.data.medicamentos">
                <div v-if="pessoa.data.medicamentos" class="subtitle-2">
                  {{ pessoa.data.medicamentos }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pessoa.data.doencas || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('doencas')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Doencas") }}
              </label>
              <restrict-chip :value="pessoa.data.doencas">
                <div v-if="pessoa.data.doencas" class="subtitle-2">
                  {{ pessoa.data.doencas }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pessoa.data.alergias || !$store.state.hideNoFilled"
              class="alergias mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('alergias')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Alergias") }}
              </label>
              <restrict-chip :value="pessoa.data.alergias">
                <div v-if="pessoa.data.alergias" class="subtitle-2">
                  {{ pessoa.data.alergias }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="
                $i18n.i18next.language === 'pt_br' &&
                (pessoa.data.numeroSus || !$store.state.hideNoFilled)
              "
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('numeroSus')"
              />
              <label class="text-caption grey--text text--darken-2">
                Número do SUS
              </label>
              <restrict-chip :value="pessoa.data.numeroSus">
                <div v-if="pessoa.data.numeroSus" class="subtitle-2">
                  {{ pessoa.data.numeroSus }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.nomeMedico || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('nomeMedico')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Medico") }}
              </label>
              <restrict-chip :value="pessoa.data.nomeMedico">
                <div v-if="pessoa.data.nomeMedico" class="subtitle-2">
                  {{ pessoa.data.nomeMedico }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.foneMedico || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pessoa/isRestrict']('foneMedico')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Telefone_Medico") }}
              </label>
              <restrict-chip :value="pessoa.data.foneMedico">
                <div v-if="pessoa.data.foneMedico" class="subtitle-2">
                  {{ pessoa.data.foneMedico }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pessoa.data.nomeEnfermeiro || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pessoa/isRestrict']('nomeEnfermeiro')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Nome_Enfermeiro") }}
              </label>
              <restrict-chip :value="pessoa.data.nomeEnfermeiro">
                <div v-if="pessoa.data.nomeEnfermeiro" class="subtitle-2">
                  {{ pessoa.data.nomeEnfermeiro }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pessoa.data.informacoes || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pessoa/isRestrict']('informacoes')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Outras_Informacoes") }}
              </label>
              <restrict-chip :value="pessoa.data.informacoes">
                <div v-if="pessoa.data.informacoes" class="subtitle-2">
                  {{ pessoa.data.informacoes }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <Form :title="title" :data="pessoa" />
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import i18next from "i18next";
import MixinGlobal from "@/mixins";
import PageHeader from "@/components/headers/page-header";
import PhotoFullscreen from "@/components/modals/photo-fullscreen";
import Form from "./form";
import RestrictChip from "@/components/chips/restrict-chip";
import RestrictIcon from "@/components/icons/restrict-icon";

export default {
  metaInfo: {
    titleTemplate: (i18next.t('Perfil') || '') + " | %s",
  },
  mixins: [MixinGlobal],
  components: {RestrictIcon, RestrictChip, PhotoFullscreen, PageHeader, Form},
  data: () => ({
    noInfo: "__",
    title: i18next.t('Perfil'),
    showPhotoFullscreen: false
  }),
  computed: {
    store() {
      return this.$store.state;
    },
    pessoa() {
      return this.$store.state.pessoa;
    },
  },
  mounted() {
    this.$nextTick(this.checkFilled);
  },
  methods: {
    checkFilled() {
      const filleds = [
        'nome', 'dataNasc', 'peso', 'altura',
        'tipoSangue', 'email', 'fone1Contato',
        'nomeContato', 'medicamentos', 'doencas',
        'numeroSus', 'nomeMedico', 'foneMedico',
        'informacoes'
      ].map(key => {
        return !!this.pessoa.data[key]
      });

      this.$store.commit('setAllFilled', !filleds.includes(false))
    }
  }
};
</script>

<style lang="scss">
.pessoa-home {

  @media(min-width: 1025px) {
    &-container {
      height: 580px;
      min-height: 580px;
      max-height: 580px;
    }
  }

  .v-avatar {
    background-color: #fff;
    border: solid 1px #e5e5e5;
  }
}
</style>
